import React from 'react';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';
import Logo from '../../assets/icons/ebrLogo.svg';

const NotFoundPage = () => {
  return (
    <div className="nf-container">
      <header className="nf-header">
        <Link to="/">
          <img src={Logo} alt="Site Logo" className="nf-logo" />
        </Link>
      </header>

      <main className="nf-main">
        <h1 className="nf-code">404</h1>
        <p className="nf-message">Oops! We can’t find the page you’re looking for.</p>
        <div className="nf-actions">
          <Link to="/dashboard" className="nf-button">Return Home</Link>
        </div>
      </main>

      <footer className="nf-footer">
        <p>Need help? Get in touch with us at <a href="mailto:emtechsupport@eberhard.com">emtechsupport@eberhard.com</a></p>
      </footer>
    </div>
  );
};

export default NotFoundPage;
